export * from './language.interface';
export * from './language.provider';
export * from './language.loader';
export * from './language.service';
export * from './missing-translation.guard';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/core/language/shared/index.ts